var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 131.24 73.28"}},_vm.$listeners),[_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"fill":"#74acc3","d":"M28.28 0l102.96 56.3-28.99 16.98L0 14.3 28.28 0z","data-name":"agua na pia","opacity":".8"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }